<template>
  <TitleContentPage :page="$page" />
</template>

<script>
import { TitleContentPage } from '@/components/templates'
import { PageMetaMixin } from '@/mixins'

export default {
  name: 'Rules',
  mixins: [PageMetaMixin],
  beetPage: 'hunt_rules',
  components: { TitleContentPage },
}
</script>
